import { Component, OnInit } from '@angular/core';
import * as Enum from '../utils/enums';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { IVariazioneAccesso } from '../interfaces/IVariazioneAccesso';

@Component({
  selector: 'app-variazione-accessi-modal',
  templateUrl: './variazione-accessi-modal.component.html',
  styleUrls: ['./variazione-accessi-modal.component.css']
})
export class VariazioneAccessiModalComponent implements OnInit {
  DTT = Enum.DATA_TABLE_TYPE_ENUM  // enum per html
  variazioneAccessi: IVariazioneAccesso[]

  constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) {
    this.variazioneAccessi = this.config.data.variazioneAccessi
  }

  ngOnInit() {
  }

}
